var FinalizationRegistryLocal = typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry;
export { FinalizationRegistryLocal as FinalizationRegistry };
//# sourceMappingURL=FinalizationRegistryWrapper.js.map